import { render, staticRenderFns } from "./MessageListView.vue?vue&type=template&id=ce0b1f02"
import script from "./MessageListView.vue?vue&type=script&lang=js"
export * from "./MessageListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports